export interface PaginationTableProps<T = any> {
  className?: string
  columns: Array<T>
  disabled?: boolean
  rows: any[]
  showOnEmpty?: boolean
  hasNextPage?: boolean
  loading?: boolean
  onLoadMore: () => void
  sortBy?: Sort
  setSortBy?: (selection: Sort) => void
  isFiltered?: boolean
  onClick?: (row: any) => void
}
export type Sort = {
  value: string
  direction: 'desc' | 'asc'
}

export enum ColumnType {
  Status = 'status',
  Audience = 'audience',
  Author = 'author',
  EditMenu = 'editMenu',
  Owners = 'owners'
}
